import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { shiftsRouter } from './routing/shiftsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { shiftsAccessControl } from './access-control/shiftsAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'shifts',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'shifts-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [shiftsRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.Fulfillment,
      subNavItems: [
        {
          type: 'item',
          labelId: 'shiftsDomain.title',
          llmDescription: 'Shifts dashboard to manage shifts and shift assignments.',
          route: 'shifts',
          accessControl: shiftsAccessControl,
          id: 'nav-item-shifts',
          position: 2,
          positionNavV3: 2,
          inToolPermissions: [
            {
              slug: Permission.ShiftsModify,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.ShiftsModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
